import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

export const WhatsAppWrapper = styled.div`
  position: fixed;
  left: 20px;
  bottom: 20px;
  z-index: 1000;
`;

export const WhatsAppLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: all 0.3s ease;
  animation: ${pulse} 2s infinite;

  svg {
    font-size: 32px;
    color: white;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: ${props => props.theme.shadows.large};
  }
`; 